import React from 'react'
import './TriangleAnimation.css'

interface StarLoadingProps {
  showLoadingMessage: boolean
}

export function TriangleLoading({ showLoadingMessage }: StarLoadingProps) {
  return (
    <div className="triangle-wrapper">
      {/* Glowing stroke star */}
      <svg viewBox="0 0 24 24" fill="none" className="triangle glowing-triangle">
        <path
          d="M12 .587l3.668 7.431 8.189 1.19-5.932 5.788 1.402 8.174L12 18.896l-7.327 3.849 1.402-8.174-5.932-5.788 8.189-1.19Z"
          strokeWidth="1"
          strokeLinejoin="round"
          className={showLoadingMessage ? 'stroke-animation-infinite' : 'stroke-static'}
        />
      </svg>

      {/* Faded backup star */}
      <svg viewBox="0 0 24 24" fill="none" className="triangle faded-triangle">
        <path
          d="M12 .587l3.668 7.431 8.189 1.19-5.932 5.788 1.402 8.174L12 18.896l-7.327 3.849 1.402-8.174-5.932-5.788 8.189-1.19Z"
          strokeWidth="1"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  )
}
